import React from "react";

const TimelineItem = ({ year, label, icon: Icon }) => {
  return (
    <div className="flex items-start relative pl-14 md:pl-20">
      {/* Icon */}
      <div className="absolute left-0 top-0 w-10 h-10 flex items-center justify-center bg-[#003366] text-white rounded-full shadow-md z-10">
        <Icon size={20} />
      </div>

      {/* Content */}
      <div className="text-left">
        <p className="text-sm font-bold text-[#003366]">{year}</p>
        <p className="text-gray-700 text-md">{label}</p>
      </div>
    </div>
  );
};

export default TimelineItem;
